<template>
  <!-- Used when user is also author -->
  <span class="RwvPostActions">
    <div
      v-for="url in post.urls"
      :key="url.title"
      class="post-action-button">

      <b-button
        size="sm"
        :variant="buttonVariant()"
        :href="url.link"
        target="_blank"
        :title="url.description"
        :alt="url.description"
        v-if="url.title && url.link">
        <i class="material-icons">{{url.iconSlug}}</i><span>&nbsp;{{url.title}}</span>
      </b-button>
      <span v-if="url.title && url.link">&nbsp;&nbsp;</span>
    </div>

    <b-button
      size="sm"
      class="post-action-button"
      :variant="buttonVariant('warning')"
      v-if="isAuthenticated"
      v-on:click="editPost">

      <i class="material-icons">edit</i><span>&nbsp;Bearbeiten</span>
    </b-button>
  </span>
</template>

<script>
export default {
  name: "RwvPostActions",
  props: {
    post: {
      type: Object,
      required: true
    },
    isAuthenticated: {
      type: Boolean,
      required: true
    },
    preview: {
      type: Boolean,
      default: false
    },
    isBook: {
      type: Boolean,
      required: true
    },
    isLightTheme: {
      type: Boolean,
      required: true
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      window.addEventListener('keyup', event => {
        if(event.altKey && event.ctrlKey && event.keyCode === 69){
          this.editPost()
        }
      })
    });
  },
  methods: {
    buttonVariant(base) {
      if (!this.isLightTheme && base) {
        return "outline-" + base
      } else if (!this.isLightTheme) {
        return "outline-light"
      } else {
        return base
      }
    },
    editPost() {
      if (this.isBook) {
        this.$router.push({ name: 'book-edit', params: { slug: this.post.slug } });
      } else {
        this.$router.push({ name: 'article-edit', params: { slug: this.post.slug } });
      }
    }
  },
};
</script>

<style lang="scss" scoped>

.material-icons {
  font-size: 1em;
  line-height: 1.2em;
}
.btn {
  margin-top: 6px;
  margin-bottom: 6px;
  &:hover {
    opacity: 1;
  }
}
.post-action-button {
  margin: 0.5em;
  // @media (min-width: 930px) {
  //   display: inline-block;
  //   margin: 0;
  // }
}
</style>
